import { observer } from 'mobx-react-lite'
import { Icon } from 'shared/ui'
import { TextField } from 'shared/ui/TextField'
import { usePowerDialerViewContext } from 'pages/powerDialer/pages/view/context/powerDialerViewContext'
import styles from './styles.module.scss'

export const PowerDialerContactsSearch = observer(() => {
  const { powerDialerContactsStore } = usePowerDialerViewContext()

  if (!powerDialerContactsStore) return null

  const { search, setSearch } = powerDialerContactsStore

  return (
    <div className={styles.search}>
      <Icon icon='search' fontSize={20} padding={6} color='var(--content-primary-tertiary)' />
      <TextField
        variant='integrated'
        InputProps={{
          placeholder: 'Search...',
        }}
        onChange={setSearch}
        value={search}
      />
    </div>
  )
})
